export const DEFAULT_MAP_CENTER = {
  lat: -7.1198902,
  lng: -34.8442192
}

export const DEFAULT_MAP_ZOOM = 15
